// extracted by mini-css-extract-plugin
export default {"drawernavigator":"a1da0616ea32a70dbbe4","header":"fa9df0dd6de661500f0d","container":"ce28c8d881d1080149a7","showbtn":"cc49a6f14c3a2ba50f6e","title":"be18f5c40360b927e5d6"};